import { LocalAddress } from './local-address.model';
import { LocalLocationContainerConfiguration } from './local-location-container-configuration.model';
import { Moment } from 'moment';
import { LocalLocationOptionConfiguration } from './local-location-option-configuration.model';
import { LocalLocationProfileConfiguration } from './local-location-profile-configuration.model';
import { LocalLocationType } from './local-location-type';
import * as moment from 'moment';

export class LocalLocationContainer {

  public id: string;
  public glid: string;
  public name: string;
  public type: LocalLocationType;
  public address: LocalAddress;
  public latitude: number;
  public longitude: number;
  public configuration: LocalLocationContainerConfiguration;
  public options: Array<LocalLocationOptionConfiguration>;
  public profiles: Array<LocalLocationProfileConfiguration>;
  public lastUpdatedAt: Moment;
  public lastUpdatedBy: string;
  public coordinatesValidated: boolean;
  public vat: string;
  public phoneNumber: string;
  public vatPhoneUpdatedAt: Moment;

  static fromDto(data: any): LocalLocationContainer {
    const container = new LocalLocationContainer();

    if (!data) {
      return null;
    }

    container.id                       = data.id;
    container.glid                     = data.glid;
    container.name                     = data.name;
    container.type                     = data.type;
    container.address                  = LocalAddress.fromDto(data.address);
    container.latitude                 = data.latitude;
    container.longitude                = data.longitude;
    container.configuration            = LocalLocationContainerConfiguration.fromDto(data.configuration);
    container.options                  = data.options ? data.options.map(option => LocalLocationOptionConfiguration.fromDto(option)) : [];
    container.profiles                 = data.profiles ? data.profiles.map(profile => LocalLocationProfileConfiguration.fromDto(profile)) : [];
    container.lastUpdatedAt            = data.last_updated_at;
    container.lastUpdatedBy            = data.last_updated_by;
    container.coordinatesValidated     = data.coordinates_validated;
    container.vat                      = data.vat;
    container.phoneNumber              = data.phone_number;
    container.vatPhoneUpdatedAt        = data.vat_phone_updated_on ? moment(data.vat_phone_updated_on) : null;

    return container;
  }

}
